import { render, staticRenderFns } from "./AsiContentContainer.vue?vue&type=template&id=18f5980c&scoped=true&"
import script from "./AsiContentContainer.vue?vue&type=script&lang=ts&"
export * from "./AsiContentContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5980c",
  null
  
)

export default component.exports